import { MdOutlineErrorOutline } from 'react-icons/md';
import { toLocalDateFromApiDateKey } from '@lp/features/Scheduler/utils';
import { formatDate } from '@/utils/helpers';

type DrawerViolationCardProps = {
  title: string;
  message: string;
  day?: string;
  onClick?: () => void;
};

export const DrawerViolationCard = ({ title, message, day, onClick }: DrawerViolationCardProps) => {
  return (
    <button
      className="flex bg-white rounded-lg border-l-8 border-danger-40 px-2 py-2 items-center gap-2 disabled:cursor-default"
      disabled={!onClick}
      onClick={onClick}
    >
      <MdOutlineErrorOutline size={24} className="text-danger-40" />
      <div className="flex flex-col w-full">
        <div className="flex justify-between items-center gap-1">
          <span className="text-danger-10 text-m-sb">{title}</span>
          {day && (
            <span className="text-base-30 text-m-r">{formatDate(toLocalDateFromApiDateKey(day), 'MM/dd/yyyy')}</span>
          )}
        </div>
        <span className="text-m-r whitespace-pre-line text-start">{message}</span>
      </div>
    </button>
  );
};
